<template>
    <div class="p-2 h-screen overflow-hidden">
        <div class="flex flex-col justify-center p-4">
            <div @click="goToHome" class="flex mx-auto" style="align-items: center;">
                <img class="w-16 object-contain" src="@/assets/img/logo.png" alt="Logo">
                <h6 class="text-6xl mb-0 font-serif font-extrabold h-fit w-fit" style="color: #7D8600;">HUET</h6>
            </div>
            <h1 class="text-center mt-1 text-2xl font-extrabold text-prime-color">Khoa Kỹ Thuật & Công Nghệ</h1>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2">
            <div class="flex items-center justify-center py-6 md:py-10">
              <div class="flex flex-col items-center justify-center max-w-2xl">
                <h1 class="text-center mb-2 text-3xl lg:text-4xl font-bold text-prime-color">Đang Bảo Trì</h1>
                <p class="text-center text-xl md:text-2xl text-gray-500">
                    Trang bạn đang tìm kiếm đang bảo trì và sẽ sớm quay trở lại.
                    <br class="d-none d-xl-block">Nếu bạn cần hỗ trợ, liên hệ với chúng tôi 
                    <a class="text-prime-color" href="https://www.facebook.com/huet.hueuni">TẠI ĐÂY</a>
                </p>
              </div>
            </div>
            <div class="d-flex justify-center">
                <img class="w-[400px] lg:w-[600px]" src="@/assets/img/error/maintenance.svg" alt="maintain">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Maintain",
    methods: {
        goToHome() {
            this.$router.push({path: '/'});
        },
    }
}
</script>